module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_maps_76b63a3be75eeb4bef0c027b3cd23970.png";